var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert_toast"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.alertInfo.title)+" ")]),_c('div',{staticClass:"content"},[_c('loading-image',{attrs:{"width":'90px',"height":'90px',"imageUrl":_vm.alertInfo.url}}),_c('div',{staticClass:"alert_text"},[_vm._v(_vm._s(_vm.alertInfo.content))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }